var map = {
	"./custom.png": "d6f4",
	"./schaudt_wa121525.png": "41ac",
	"./victron_smart_24_12_20.png": "0be0",
	"./victron_smart_24_12_30.png": "7afc",
	"./victron_smart_24_24_12.png": "4540",
	"./votronic_20A.png": "0653"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47a6";